import { RebrandPopup } from "@/components/growth/RebrandPopup";
import { PointsGate } from "@/components/PointsGate";
import { InviteWelcome } from "@/components/growth/InviteWelcome";
import { InviteRulesPopup } from "@/components/growth/InviteRules";
import { useUrgent, UrgentDot } from "@/lib/urgent";
import { useGameBadges } from "@/lib/gameBadges";
import { StoryRingHost } from "@/lib/storyRings";
import { NextRewardStrip } from "./NextRewardStrip";
import { PullToRefresh } from "@/components/PullToRefresh";
import { useEffect, useState } from "react";
import { NavLink, Outlet, Link, useNavigate, useLocation } from "react-router-dom";
import { MessagesSquare, Home, PlayCircle, Gift, UserPlus, Bell, User, Shield, LogOut, Coins, Flame, Trophy, Users, Menu, Settings, BellRing, Mail, Crown, Gamepad2, Swords, PawPrint, SmilePlus, Heart, Sparkles, Award, HeartHandshake, Smartphone, Coffee } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Logo } from "./Logo";
import { MourningRibbon } from "./MourningRibbon";
import { LegalLinks } from "@/pages/Legal";
import { HomeScreenHint } from "./HomeScreenHint";
import { ReportErrorButton } from "./ReportError";
import { PointsBurst, PointsBadge } from "@/components/PointsBurst";
import { LuckyWheel } from "./LuckyWheel";
import { LevelUpWatcher } from "./LevelUp";
import { EmailConsentPrompt } from "./EmailConsentPrompt";
import { JackpotCelebration } from "./JackpotCelebration";
import { RedeemCelebration } from "./RedeemCelebration";
import { WelcomeBack } from "./WelcomeBack";
import { VipCelebration } from "./VipCelebration";
import { HonorWelcome } from "./HonorWelcome";
import { DuelCelebration } from "./games/DuelCelebration";
import { ScratchBigCelebration } from "./games/ScratchBigCelebration";
import { LottoJackpotCelebration } from "./LottoJackpotCelebration";
import { HeartClaim } from "@/pages/HeartLink";
import { InstallPrompt, InstallBonus, PushAfterInstall } from "./InstallPrompt";
import { MobileHeader, BottomTabs } from "./MobileHeader";
import { HeaderHeart } from "./csupport/HeaderHeart";
import { TikTokLiveBar, TikTokLiveSpacer } from "./TikTokLive";
import { AllInInbox } from "./games/AllInGifts";
import { SupportBar, SupportBarSpacer } from "./SupportBar";
import { QuestEventBar, QuestEventBarSpacer, useQuestLive } from "./quest/QuestEventBar";
import { DailyMissionsBar, DailyMissionsBarSpacer, useDailyBar } from "./quest/DailyMissionsBar";
import { HalloweenPopup } from "./halloween/HalloweenPopup";
import { unlockAudio } from "@/lib/celebrate";
import { TreasureSpot } from "./Treasure";
import { GoldRain, GoldRainBanner, GoldRainSpacer } from "./GoldRain";
import { WhatsAppNewbieHint } from "./whatsapp/WhatsAppNewbieHint";
import { DropBubble } from "./drops/Drops";
import { useGoldRain } from "@/lib/goldrain";
import { useGames, gameOn, gameBlocked, ROUTE_GAME } from "@/lib/games";
import { useFeedOnOpen, useScrollTopOnRoute } from "@/lib/useFeedOnOpen";
import { usePageMeta } from "@/lib/seo";
import { LegalConsentGate } from "@/components/LegalConsentGate";

const navItems = (uid) => [
  { to: "/feed", label: "Home", icon: Home, id: "feed" },
  { to: "/community", label: "Entdecken", icon: Users, id: "community" },
  { to: "/spiele", label: "Spielen", icon: Gamepad2, id: "games" },
  { to: "/geschenke", label: "Prämien", icon: Gift, id: "rewards" },
  { to: `/u/${uid}`, label: "Profil", icon: User, id: "profile" },
];

export const MORE = [
  { to: "/profil", label: "Profil bearbeiten", sub: "Bild, Bio & Push", icon: User, id: "profile-edit", g: "Mein Konto" },
  { to: "/nachrichten", label: "Nachrichten", sub: "Deine Chats", icon: Mail, id: "messages", g: "Mein Konto" },
  { to: "/stimmung", label: "Stimmung & Tagebuch", sub: "Wie geht's dir heute?", icon: SmilePlus, id: "mood", g: "Mein Konto" },
  { to: "/einstellungen", label: "Einstellungen & Daten", sub: "Konto, Daten, Sperren", icon: Settings, id: "settings", g: "Mein Konto" },
  { to: "/push", label: "Push-Anleitung", sub: "Nichts mehr verpassen", icon: BellRing, id: "push", g: "Mein Konto" },
  { to: "/app", label: "App installieren", sub: "Aufs Handy holen", icon: Smartphone, id: "app", g: "Mein Konto" },
  { to: "/dashboard", label: "Punkte & Login-Bonus", sub: "Dein Punktestand", icon: Coins, id: "dashboard", g: "Punkte & Prämien" },
  { to: "/geschenke", label: "Prämien & Geschenke", sub: "Punkte eintauschen", icon: Gift, id: "rewards", g: "Punkte & Prämien" },
  { to: "/punkte-sammeln", label: "So sammelst du Punkte", sub: "Alle Wege im Überblick", icon: Sparkles, id: "points-guide", g: "Punkte & Prämien" },
  { to: "/einladen", label: "Freunde einladen", sub: "Bonus für euch beide", icon: UserPlus, id: "invite", g: "Punkte & Prämien" },
  { to: "/rangliste", label: "Top 10", sub: "Die Besten der Woche", icon: Trophy, id: "leaderboard", g: "Punkte & Prämien" },
  { to: "/ruhmeshalle", label: "Ruhmeshalle", sub: "Unsere Legenden", icon: Crown, id: "hall-of-fame", g: "Punkte & Prämien" },
  { to: "/team", label: "Unser Team", sub: "Projektleitung & Moderatoren", icon: Shield, id: "team", g: "Community" },
  { to: "/ehrenwand", label: "Ehrenwand", sub: "Unsere Ehrenmitglieder", icon: Award, id: "honor-wall", g: "Community" },
  { to: "/unterstuetzer", label: "Projekt Unterstützer", sub: "Danke an alle", icon: HeartHandshake, id: "supporters", g: "Community" },
  { to: "/danke-stefan", label: "Danke, Stefan!", sub: "Unser Mitbegründer", icon: Crown, id: "thanks-stefan", g: "Community" },
  { to: "/tasse", label: "Die Dankeschön-Tasse", sub: "Neu & limitiert", icon: Gift, id: "mug-present", g: "Community" },
  { to: "/dankeschoen-tasse", label: "Meine Dankeschön-Tasse", sub: "Bestellung verfolgen", icon: Coffee, id: "mug", g: "Community" },
  { to: "/community-unterstuetzen", label: "Unterstützer werden", sub: "Exklusive Vorteile", icon: Heart, id: "support", g: "Community", gold: true },
];
export const MORE_GROUPS = ["Mein Konto", "Punkte & Prämien", "Community"];

const navCls = ({ isActive }) =>
  `relative flex items-center gap-2 px-3 py-2 rounded-full text-sm font-semibold transition-colors duration-200 ${isActive ? "bg-rose-500 text-white" : "text-slate-600 hover:bg-rose-50 hover:text-rose-600"}`;

function useUnread(endpoint, event) {
  const [count, setCount] = useState(0);
  const { pathname } = useLocation();
  useEffect(() => {
    const load = () => api.get(endpoint).then(({ data }) => setCount(data.count)).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    window.addEventListener(event, load);
    return () => { clearInterval(t); window.removeEventListener(event, load); };
  }, [pathname, endpoint, event]);
  return count;
}

const Dot = ({ n, testId }) => n > 0 && <span key={n} data-testid={testId} className="badge-pop absolute -top-1 right-0 min-w-4 h-4 px-1 rounded-full bg-rose-500 text-white text-[10px] font-bold flex items-center justify-center border-2 border-white">{n > 9 ? "9+" : n}</span>;

export const useMore = () => {
  const cfg = useGames();
  return MORE.filter((m) => gameOn(cfg, ROUTE_GAME[m.to]));
};

function MoreMenu({ isAdmin, onLogout }) {
  const navigate = useNavigate();
  const more = useMore();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger data-testid="more-menu-btn" className="p-2 rounded-full text-slate-500 hover:bg-rose-50 hover:text-rose-600 transition-colors" title="Mehr"><Menu className="w-5 h-5" /></DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[38rem] rounded-3xl p-4 max-h-[80vh] overflow-y-auto">
        {MORE_GROUPS.map((g) => (
          <div key={g} className="mb-3">
            <p className="px-1 pb-2 text-[10px] font-extrabold uppercase tracking-[0.2em] text-rose-400">{g}</p>
            <div className="grid grid-cols-3 gap-2">
              {more.filter((m) => m.g === g).map((m) => (
                <DropdownMenuItem key={m.to} onSelect={() => navigate(m.to)} data-testid={`more-${m.id}`}
                  className={`rounded-2xl p-3 flex-col items-start gap-2 cursor-pointer border ${m.gold ? "vip-gold-bg border-amber-400/50 focus:bg-[#3b0d1c]" : "bg-white border-pink-100 focus:bg-rose-50"}`}>
                  <span className={`w-8 h-8 rounded-lg flex items-center justify-center ${m.gold ? "bg-amber-300/20 text-amber-300" : "pink-gradient text-white"}`}><m.icon className="w-4 h-4" /></span>
                  <span className="min-w-0"><span className={`block text-sm font-bold leading-tight ${m.gold ? "vip-gold-text" : ""}`}>{m.label}</span><span className={`block text-[11px] leading-tight mt-0.5 ${m.gold ? "text-amber-200/80" : "text-slate-500"}`}>{m.sub}</span></span>
                </DropdownMenuItem>
              ))}
            </div>
          </div>
        ))}
        {isAdmin && <DropdownMenuItem onSelect={() => navigate("/admin")} data-testid="more-admin" className="rounded-xl gap-2 py-2.5 cursor-pointer font-semibold text-rose-600"><Shield className="w-4 h-4" /> Admin-Bereich</DropdownMenuItem>}
        <DropdownMenuSeparator />
        <div className="px-2.5 py-1.5"><LegalLinks className="text-xs font-semibold text-slate-400" /></div>
        <DropdownMenuSeparator />
        <DropdownMenuItem onSelect={onLogout} data-testid="logout-btn" className="rounded-xl gap-2 py-2.5 cursor-pointer text-slate-500"><LogOut className="w-4 h-4" /> Abmelden</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default function Layout() {
  usePageMeta({ noindex: true });
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const unread = useUnread("/notifications/unread-count", "notifications-read");
  const unreadMsgs = useUnread("/messages/unread-count", "messages-read");
  const { pathname } = useLocation();
  const gameBadges = useGameBadges(pathname);
  const gamesWaiting = Object.values(gameBadges).some(Boolean);
  const games = useGames();
  const gold = useGoldRain(user?.user_id);
  const questLive = useQuestLive();
  const dailyBar = useDailyBar(!!user && questLive === null);
  const nav = navItems(user?.user_id);
  const doLogout = async () => { await logout(); navigate("/"); };
  useFeedOnOpen();
  useEffect(() => {
    const ref = new URLSearchParams(window.location.search).get("gm");
    if (!ref || !user) return;
    api.post(`/nudge/${ref}/click`).catch(() => {});
    const u = new URL(window.location.href); u.searchParams.delete("gm");
    window.history.replaceState(null, "", u.pathname + u.search + u.hash);
  }, [pathname, user?.user_id]); // eslint-disable-line react-hooks/exhaustive-deps
  useScrollTopOnRoute();
  const urgent = useUrgent(!!user);
  useEffect(() => {
    const up = () => unlockAudio();
    window.addEventListener("pointerdown", up, { once: true });
    return () => window.removeEventListener("pointerdown", up);
  }, []);

  return (
    <div className="min-h-screen noise-bg">
      <header className="fixed top-0 inset-x-0 z-40 glass">
        <TikTokLiveBar />
        <SupportBar />
        <QuestEventBar q={questLive} />
        <DailyMissionsBar m={dailyBar} />
        <GoldRainBanner ev={gold.ev} offset={gold.offset} myCoins={gold.ev?.my_coins || 0} blocked={!!games && gameBlocked(games, "goldrain")} />
        <div className="hidden lg:flex max-w-7xl mx-auto px-6 h-16 items-center justify-between gap-4">
          <span className="flex items-center gap-4"><Logo to="/feed" /><MourningRibbon /></span>
          <nav className="hidden lg:flex items-center gap-1">
            {nav.map((n) => (
              <NavLink key={n.id} to={n.to} className={navCls} data-testid={`nav-${n.id}`}>
                <n.icon className="w-4 h-4" /> {n.label}{n.badge && <Dot n={unread} testId="nav-unread-badge" />}{n.id === "feed" && <span className="relative w-0 h-3 -ml-1"><UrgentDot on={urgent} testId="nav-feed-urgent" /></span>}{n.id === "games" && gamesWaiting && <span className="w-2.5 h-2.5 -ml-0.5 rounded-full bg-red-500 tile-dot" data-testid="nav-games-dot" />}
              </NavLink>
            ))}
          </nav>
          <div className="flex items-center gap-1 sm:gap-2">
            <PointsBadge points={user?.points ?? 0} testId="header-points-badge" className="px-3 py-1.5" />
            <HeaderHeart />
            <NavLink to="/mitteilungen" data-testid="nav-notifications" title="Mitteilungen" className="relative p-2 rounded-full text-slate-500 hover:bg-rose-50 hover:text-rose-600 transition-colors"><Bell className="w-5 h-5" /><Dot n={unread} testId="nav-unread-badge" /></NavLink>
            <Link to="/nachrichten" data-testid="header-messages-link" title="Nachrichten" className="relative p-2 rounded-full text-slate-500 hover:bg-rose-50 hover:text-rose-600 transition-colors"><Mail className="w-5 h-5" /><Dot n={unreadMsgs} testId="header-messages-badge" /></Link>
            <MoreMenu isAdmin={user?.role === "admin"} onLogout={doLogout} />
          </div>
        </div>
        <MobileHeader points={user?.points ?? 0} unread={unread} unreadMsgs={unreadMsgs} />
      </header>
      <BottomTabs urgent={urgent} gamesWaiting={gamesWaiting} />
      <InviteWelcome />
      <RebrandPopup />
      <InviteRulesPopup />
      {user && <AllInInbox />}
      <main className="relative max-w-6xl mx-auto px-4 sm:px-6 pt-[92px] lg:pt-24 pb-[calc(8rem+env(safe-area-inset-bottom))] lg:pb-16">
        <TikTokLiveSpacer />
        <SupportBarSpacer />
        <QuestEventBarSpacer q={questLive} />
        <DailyMissionsBarSpacer m={dailyBar} />
        <GoldRainSpacer ev={gold.ev} offset={gold.offset} />
        {pathname === "/dashboard" && <HomeScreenHint />}
        <PointsGate />
        <NextRewardStrip />
        <StoryRingHost />
        {games && gameOn(games, "wheel") && !gameBlocked(games, "wheel") && !pathname.startsWith("/spiele/") && <LuckyWheel />}
        <LevelUpWatcher />
        <HalloweenPopup />
        <EmailConsentPrompt />
        <JackpotCelebration />
        <RedeemCelebration />
        <WelcomeBack />
        <VipCelebration />
        <HonorWelcome />
        <DuelCelebration />
        <ScratchBigCelebration />
        <LottoJackpotCelebration />
        <InstallPrompt />
        <HeartClaim />
        <InstallBonus />
        <WhatsAppNewbieHint />
        <DropBubble />
        <PushAfterInstall />
        <PointsBurst />
        <GoldRain {...gold} blocked={!games || gameBlocked(games, "goldrain")} />
        <PullToRefresh />
        <div key={pathname} className="page-enter"><Outlet /></div>
        <LegalConsentGate />
        {games && gameOn(games, "treasure") && !gameBlocked(games, "treasure") && <TreasureSpot pathname={pathname} />}
        <div className="mt-12 flex justify-center"><ReportErrorButton /></div>
      </main>
    </div>
  );
}
